(function () {
  'use strict';

  angular
    .module('trainingRoster')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('trainingRoster', {
        url: '/training-roster',
        views : {
          'trainingRosterView' : {
            templateUrl: 'training-roster/views/training-roster.tpl.html',
            controller: 'TrainingRosterCtrl',
            controllerAs: 'trainingRoster'
          }
        }
      });
  }
}());
